import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBlackDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#212529",
		fillRule: "evenodd",
		d: "M17.366 9.135c-.18-.18-.47-.18-.648 0L12 13.885l-4.718-4.75c-.179-.18-.468-.18-.648 0-.179.18-.179.472 0 .653l5.042 5.077c.09.09.207.135.324.135.117 0 .235-.045.324-.135l5.042-5.077c.179-.18.179-.472 0-.653z"
	})
});
export default SvgArrowBlackDown;
